import { sort } from 'fast-sort';

export default class Sort {
  public static asc<T = {}>(column: string, arr: Array<T>): Array<T> {
    const isNumericColumn = Sort.isNumericColumn(column, arr);
    // @ts-ignore
    return sort(arr).asc((x) => Sort.key(x[column], isNumericColumn));
  }

  public static desc<T = {}>(column: string, arr: Array<T>): Array<T> {
    const isNumericColumn = Sort.isNumericColumn(column, arr);
    // @ts-ignore
    return sort(arr).desc((x) => Sort.key(x[column], isNumericColumn));
  }

  /**
   * 컬럼 전체가 숫자(빈값 제외)일 때만 숫자 정렬.
   * 행마다 숫자/문자 키를 섞어 비교하면 순서가 불안정해져 정렬이 안 된 것처럼 보인다.
   */
  private static isNumericColumn(column: string, arr: Array<any>): boolean {
    let hasNumber = false;

    for (let i = 0; i < arr.length; i += 1) {
      const v = arr[i]?.[column];
      if (v !== undefined && v !== null && v !== '') {
        if (!Sort.isNumeric(String(v))) return false;
        hasNumber = true;
      }
    }

    return hasNumber;
  }

  private static key(v: any, isNumericColumn: boolean): any {
    if (isNumericColumn) {
      // 빈값은 null로 — fast-sort가 오름/내림 모두 끝으로 보낸다
      if (v === undefined || v === null || v === '') return null;
      return parseFloat(String(v).replace(/,/g, ''));
    }
    return v;
  }

  private static isNumeric(n: string) {
    const s = n.replace(/,/g, '');
    if (!/^-?[0-9]+(\.[0-9]+)?$/.test(s)) return false;
    const f = parseFloat(s);
    return !Number.isNaN(f) && Number.isFinite(f);
  }
}
